import type { PostHogProvider } from "posthog-js/react";

const isDevelopment = import.meta.env.DEV;

export const POSTHOG_PROVIDER_OPTIONS: React.ComponentProps<typeof PostHogProvider> = {
    apiKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
    options: {
        // config
        debug: isDevelopment,
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST!,
        ui_host: "eu.posthog.com",
        defaults: "2025-05-24",
        // tracking
        capture_pageview: !isDevelopment,
        autocapture: true,
        // misc flags
        disable_surveys: false,
        disable_surveys_automatic_display: true,
    },
};
